// @flow

import { AddressEditorComponent } from './address-editor-component';
import { AddressEditorTemplatesDefault } from './templates';

export const COMPONENTS_ADDRESS_EDITOR_NAME = 'address-editor';

export const COMPONENTS_ADDRESS_EDITOR_ENTITIES = [
	{
		name: COMPONENTS_ADDRESS_EDITOR_NAME,
		entity: AddressEditorComponent,
		template: AddressEditorTemplatesDefault,
	},
];
